import { Fireworks } from 'fireworks-js'
import { incScore } from './trophy.mjs';
import { refresh } from './game.mjs';
import { resetDestination } from './buttons.mjs';
import { settings } from './settings.mjs';

//import Cookies from "js-cookie";

var result = false;

function getRandomTime(fiveMinutesInterval=false){
    const hours = Math.floor(Math.random() * 12) + 1;
    
    const minutesArray = [5, 10, 15, 20, 25];
    
    const minutes = (fiveMinutesInterval) 
                        ? 
                        minutesArray[Math.floor(
                            Math.random() * minutesArray.length)] 
                        :
                        //Math.floor(Math.random() * 58) + 1;
                        Math.floor(Math.random() * 28) + 1;
    
    return {
        h: hours,
        m: minutes
    }
}

function getRandomMinutes(notArray=[]){
    let rnd = Math.floor(Math.random() * 28) + 1;
    return (notArray.includes(rnd)) ? getRandomMinutes(notArray): rnd;
}

function makeWrongMinutes(m, difficulty) {

    if (difficulty.fiveMinutesInterval) {
        return [
            (m < 25) ? (m + 5).toString() : (5).toString(),
            (m == 5) ? (5).toString() : (m - 5).toString()
        ]
    } else {
        let first = getRandomMinutes([m]);
        let second = getRandomMinutes([m, first]);
        return [
            first.toString(),
            second.toString()
        ]
    }
}


function challengeType() {
    /* prevent same consecutive type and types 0 and 1 following */
    let type = Math.floor(Math.random() * 4);
    //let lastType = parseInt( Cookies.get('lastType') );
    let lastType = parseInt( window.sessionStorage.getItem('lastType') );
    return (type === lastType || type + lastType === 1) ? challengeType() : (
                //Cookies.set('lastType', type, { sameSite: 'strict' }), type);
                window.sessionStorage.setItem('lastType', type), type);
}

export function makeChallenge(difficulty){
    /**
     * return arr[minutes, hours, solution]
     */

    /*
    types:
        0: klokken hel
        1: klokken halv
        2: x minutter over
        3: x minutter i
    */
    //const type = Math.floor(Math.random() * 4);
    const type = challengeType();
    console.log('type: ' + type);

    const time = getRandomTime(difficulty.fiveMinutesInterval);
    const h = time.h
    const m = time.m

    switch (type) {
        case 0:             // klokken hel
            return {
                m: 0,
                h: h, 
                solution: [ h.toString() ],
                wrong: [
                    'halv',
                    '12',
                    (h < 12) ? (h + 1).toString() : (1).toString(),
                    (h == 1) ? (12).toString(): (h - 1).toString()
                ]
            };
        
        case 1:             // klokken halv
            return {
                m: 30,
                h: h, 
                solution: [
                    'halv', (h < 12) ? (h + 1).toString() : (1).toString()
                    /* ['30', 'minutter over', h.toString()]*/
                ],
                wrong: [
                    '6',
                    (h < 12) ? (h).toString() : (1).toString(),
                    (h == 1) ? (12).toString(): (h - 1).toString()
                ]
            };

        case 2:             // x minutter over
            return {
                m: m,
                h: h,
                solution: [ m.toString(), 'minutter over', h.toString() ],
                wrong: [
                    'minutter i',
                    (h < 12) ? (h + 1).toString() : (1).toString(),
                    (h == 1) ? (12).toString(): (h - 1).toString(),
                    ...makeWrongMinutes(m, difficulty)
                ]
            };
        
        case 3:             // x minutter i
            return {
                //m: m + 30,
                m: 60 - m,
                h: h,
                solution: [
                    //Math.abs(m - 30).toString(),
                    m.toString(),
                    'minutter i',
                    (h < 12) ? (h + 1).toString() : (1).toString()
                ],
                wrong: [
                    'minutter over',
                    (h < 12) ? (h).toString() : (1).toString(),
                    (h == 1) ? (12).toString(): (h - 1).toString(),
                    ...makeWrongMinutes(m, difficulty)
                    /*(m < 25) ? (m + 5).toString() : (5).toString(),
                    (m == 5) ? (5).toString() : (m - 5).toString()*/
                ]
            };

        default:
            console.log("Error in challenge.js");
            break;
    }
}

export function checkChallenge(solution, answer){
    let correct = 
        solution.length === answer.length &&
        solution.every((element, index) => element === answer[index]);
    
        //console.log(solution, answer)
        //console.log(correct);

    result = correct;

    /* fireworks */
    if (correct) {

        incScore();
        const svg = document.querySelector('#trophy');
        svg.classList.add('svg_animate');

        const container = document.getElementById('fireworks');
        container.style.zIndex = 1000; /* test. may cause problems */
        const fireworks = new Fireworks(container, settings.fireworkSettings);
        
        const numberOfRockets = container.clientWidth > 1024 ? 20 : 10;
        
        fireworks.launch(numberOfRockets);
        //fireworks.start();

        setTimeout(refresh, 2000);

    } else {
        // incTotal();
        const container = document.getElementById('canvas');
        container.classList.add('error_animate');
        setTimeout(()=> container.classList.remove('error_animate'),1000);
        resetDestination();
    }
}


export function getResult() {
    return result;
}

function r(){
    h = Math.floor(Math.random() * 12) + 1;
    console.log('h is: ' + h);

    hh = (h < 12) ? h + 1 : 1

    console.log('hh is: ' + hh);
}

/*
switch (Math.floor(Math.random() * 4)) {
        case 0:
            console.log("type 0");
            return [
                0, h, 
                [h.toString()]
            ];
        
        case 1:
            console.log("type 1");
            return [
                30, h, 
                [
                    ['30', 'minutter over', h.toString()],
                    ['halv', (h < 12) ? (h + 1).toString() : (1).toString() ]
                ]
            ];

        case 2:
            console.log("type 2");
            return [
                m, h, 
                [m.toString(), 'minutter over', h.toString()]
            ];
        
        case 3:
            console.log("type 3");
            return [
                m + 30, h, 
                [Math.abs(m - 30).toString(), 'minutter i', (h < 12) ? (h + 1).toString() : (1).toString()]
            ];

        default:
            console.log("Error in challenge.js");
            break;
    }
    */